<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-register-success custom-alert-modal"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="ic-success-wrapper">
                <img src="../../../assets/icon/ic-success.svg" />
            </div>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close"></div>
                    <div class="text-title">{{ lbl.register.modal_success_title }}</div>
                </div>
                <div class="modal-base-body">
                    <div class="text-sub-title">{{ lbl.register.modal_success_subtitle }}</div>
                </div>
                <div class="desktop-show">
                    <div class="store-wrapper">
                        <div class="store-item">
                            <vue-qrcode id="qrcode"
                                :value="'https://apps.apple.com/us/app/bhpetrol-ecard/id1461459706'"
                                :options="objQrCodeConfig">
                            </vue-qrcode>
                            <img @click="clickOpenStore('https://apps.apple.com/us/app/bhpetrol-ecard/id1461459706')" src="../../../assets/icon/ic-apple-store.svg" />
                        </div>
                        <div class="store-item">
                            <vue-qrcode id="qrcode"
                                :value="'https://play.google.com/store/apps/details?id=com.bzbs.bhpetrol'"
                                :options="objQrCodeConfig">
                            </vue-qrcode>
                            <img @click="clickOpenStore('https://play.google.com/store/apps/details?id=com.bzbs.bhpetrol')" src="../../../assets/icon/ic-play-store.svg" />
                        </div>
                    </div>
                    <button class="btn-white" @click="hide()">{{lbl.default.close}}</button>
                </div>
                <div class="modal-base-footer desktop-hidden">
                    <button class="btn-orange" @click="clickOk()">{{lbl.register.download_app}}</button>
                    <button class="btn-white" @click="hide()">{{lbl.default.close}}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "RegisterSuccessModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    components: {
        VueQrcode
    },
    data: function() {
        return {
            isShowSmallClose: false,
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),

            objQrCodeConfig: {
                width: 140
            }
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickSmallClose: function() {
            this.hide();
            this.controller.sendCallbackSmallClose({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.isShowSmallClose = config.isShowSmallClose;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        clickOpenStore: function (link) {
            window.open(link)
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
.modal-register-success {

    @extend %modal-base;
    .modal {
        position: fixed;
        bottom: 0;
        z-index: 1050;
        width: 100%;
        height: auto;
    }
    .modal-dialog {
        margin: 0;
        max-width: 100%;
        height: 100%;

        .modal-content {
            margin: 0;
            margin-left: auto;
            margin-right: auto;
            margin-top: auto;
        }
    }

    // @extend %modal-base;

    .desktop-hidden {
        @media (min-width: $min-width-tablet) {
            display: none;
        }
    }
    .desktop-show {
        display: none;
        margin-top: 30px;
        .store-wrapper {
            display: flex;
            margin-bottom: 30px;

            .store-item {
                text-align: center;

                img {
                    height: 50px;
                    width: auto;
                    margin-top: 20px;
                }
            }
        }

        @media (min-width: $min-width-tablet) {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 0;
        z-index: 1050;
        width: 100%;
        height: auto;
    }
    .modal-dialog {
        margin: 0;
        max-width: 100%;
        height: 100%;
        .modal-content {
            border: 0px;
            border-radius: 0px;
            border-top-right-radius: 20px;
            border-top-left-radius: 20px;
            margin-top: auto;

            @media (min-width: $min-width-tablet) {
                margin-top: unset;
                margin: auto;
                border-radius: 20px;
                max-width: 390px;
            }
            .modal-body {
                padding: 30px 45px;
            }
            .ic-success-wrapper {
                text-align: center;
                margin-top: -65px;

                img {
                    width: 64px;
                    height: 64px;
                }
            }
            .modal-base {

                .modal-base-head {
                    .text-title {
                        text-align: center;
                        font-size: 18px;
                        color: #F06523;
                        font-weight: 700;
                        // text-transform: uppercase;
                        margin-top: 10px;
                    }
                }

                .modal-base-body {
                    padding: 0;
                    .text-sub-title {
                        text-align: center;
                        font-size: 16px;
                        color: #000000;
                        font-weight: 400;
                        margin-top: 10px;
                    }
                }
                .modal-base-footer {
                    margin-top: 30px;
                    button {
                        padding: 0;
                    }
                    .btn-white {
                        margin-top: 16px;
                    }
                }
            }
        }
    }

}
</style>
